var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseDataForm',{attrs:{"formReady":this.formReady}},[_c('CreateProductForm',{attrs:{"form":_vm.productForm,"mode":this.$props.mode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }